// extracted by mini-css-extract-plugin
export default {"container":"jxs30_","column":"DE6um2","lg":"ht4jqD","accessibilityThemeContainer":"oYeTSz"};